import { PMProvider } from "../../context/PMContext";
import { useState } from "react";
import PMSidebar from "./PMSidebar";
import PMTopbar from "./PMTopbar";
import PMDashPg from "./PMDashPg";
import PMProjectsPg from "./PMProjectsPg";
import PMProgressPg from "./PMProgressPg";
import PMLeavePg from "./PMLeavePg";
import PMChatPg from "./PMChatPg";
import PMAnnouncePg from "./PMAnnouncePg";
import PMReportsPg from "./PMReportsPg";
import PMProfilePg from "./PMProfilePg";
import PMNotesPg from "./PMNotesPg";
import PMPermsPg from "./PMPermsPg";
import PMPeoplePg from "./PMPeoplePg";
import PMNotifPg from "./PMNotifPg";
import PMTicketsPg from "./PMTicketsPg";
import PMAdvancesPg from "./PMAdvancesPg";
import PMCalendarPg from "./PMCalendarPg";
import PMHrRequestsPg from "./PMHrRequestsPg";
import PMOffboardingMgmtPg from "./PMOffboardingMgmtPg";
import PMLostReportsPg from "./PMLostReportsPg";
import PMEvalsPg from "./PMEvalsPg";
import '../../assets/styles/pm.css';

function PMPageView({ activeView, onNav }) {
  switch (activeView) {
    case "dashboard": return <PMDashPg />;
    case "projects": return <PMProjectsPg />;
    case "progress": return <PMProgressPg />;
    case "leave": return <PMLeavePg />;
    case "chat": return <PMChatPg />;
    case "announce": return <PMAnnouncePg />;
    case "reports": return <PMReportsPg />;
    case "hrrequests": return <PMHrRequestsPg />;
    case "offboardingmanagement": return <PMOffboardingMgmtPg />;
    case "notes": return <PMNotesPg />;
    case "permissions": return <PMPermsPg />;
    case "people": return <PMPeoplePg />;
    case "tickets": return <PMTicketsPg />;
    case "advances": return <PMAdvancesPg />;
    case "calendar": return <PMCalendarPg />;
    case "notifications": return <PMNotifPg onNavigate={onNav} />;
    case "lostreports": return <PMLostReportsPg />;
    case "evaluations": return <PMEvalsPg />;
    case "profile": return <PMProfilePg />;
    default: return <PMDashPg />;
  }
}

function PMDashboardInner({ onLogout }) {
  const [activeView, setActiveView] = useState("dashboard");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  
  return (
    <div className={`R ${sidebarOpen ? "sb-open" : "sb-collapsed"}`}>
      <div className="SB-hotzone" onMouseEnter={() => setSidebarOpen(true)} />
      <button
        type="button"
        className="SB-peek"
        onMouseEnter={() => setSidebarOpen(true)}
        aria-label={sidebarOpen ? "Hide menu" : "Show menu"}
      >
        {sidebarOpen ? "‹" : "›"}
      </button>
      <PMSidebar 
        activeView={activeView} 
        setActiveView={setActiveView} 
        onLogout={onLogout} 
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
      />
      <div className="MW">
        <PMTopbar 
          activeView={activeView} 
          setActiveView={setActiveView} 
          onLogout={onLogout} 
        />
        <div className="MC" key={activeView}>
          <PMPageView activeView={activeView} onNav={setActiveView} />
        </div>
      </div>
    </div>
  );
}

export default function PMDashboard(props) {
  return (
    <PMProvider>
      <PMDashboardInner {...props} />
    </PMProvider>
  );
}
